import { memo } from 'react';

type CustomMarkerEndProps = {
  id: string;
  color?: string;
};

export const CustomMarkerEnd = memo(({ id, color = '#000000' }: CustomMarkerEndProps) => {
  // Following magical code is copied from https://reactflow.dev/examples/edges/markers
  return (
    <svg style={{ position: 'absolute', top: 0, left: 0 }}>
      <defs>
        <marker
          className="react-flow__arrowhead"
          id={id}
          markerWidth="20"
          markerHeight="20"
          viewBox="-10 -10 20 20"
          markerUnits="userSpaceOnUse"
          orient="auto-start-reverse"
          refX="0"
          refY="0"
        >
          <polyline
            className="arrowclosed"
            style={{
              strokeWidth: 1,
              stroke: color,
              fill: color,
            }}
            strokeLinecap="round"
            strokeLinejoin="round"
            points="-5,-4 0,0 -5,4 -5,-4"
          />
        </marker>
      </defs>
    </svg>
  );
});

CustomMarkerEnd.displayName = 'CustomMarkerEnd';
